import { render, staticRenderFns } from "./Burn.vue?vue&type=template&id=3f4764cd&"
import script from "./Burn.vue?vue&type=script&lang=js&"
export * from "./Burn.vue?vue&type=script&lang=js&"
import style0 from "./Burn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports